import React from "react";

import { Flex, Spin, Typography } from "components";

export type LoadingStateCardProps = {
  title?: string;
  description?: string;
  dataTestId?: string;
  className?: string;
  containerClassName?: string;
  minHeight?: string;
};

export const LoadingStateCard = ({
  title,
  description,
  dataTestId = "loading-state-card",
  className = "",
  containerClassName = "",
  minHeight = "15rem",
}: LoadingStateCardProps) => (
  <div data-testid={dataTestId} className={className}>
    <div className={containerClassName}>
      <Flex vertical={true} align="center" justify="center" style={{ height: "100%", padding: "2rem 1rem", minHeight }}>
        <Spin iconName="tabler/loader" size="large" color="#100C06" className="margin-bottom-200" style={{ transform: "scale(1.5)" }} />
        {title && (
          <Typography variant="h5" data-testid={`${dataTestId}-title`} className="margin-bottom-100" style={{ textAlign: "center", fontWeight: 600 }}>
            {title}
          </Typography>
        )}
        {description && (
          <Typography
            variant="paragraph-m"
            data-testid={`${dataTestId}-description`}
            className="margin-bottom-150"
            style={{ textAlign: "center", maxWidth: "25rem" }} // 400px
          >
            {description}
          </Typography>
        )}
      </Flex>
    </div>
  </div>
);
